import { Formatter } from 'angular-slickgrid';

function isCheckedValue(value: unknown): boolean {
  if (typeof value === 'string') {
    const normalizedValue = value.trim().toLowerCase();

    if (!normalizedValue || ['0', 'false', 'no', 'n', 'off'].includes(normalizedValue)) {
      return false;
    }
  }

  return Boolean(value);
}

export const checkboxFormatter: Formatter = (_row, _cell, value, columnDef) => {
  const isChecked = isCheckedValue(value);
  const stateClass = isChecked ? 'checkmark-cell--checked' : 'checkmark-cell--unchecked';
  const isDisabled = ['column-disabled', 'disabled'].some(className =>
    String((columnDef as any)?.cssClass ?? '').includes(className)
  );
  const disabledClass = isDisabled ? 'checkmark-cell--disabled disabled' : '';

  return `
    <span class="checkmark-cell ${stateClass} ${disabledClass}" aria-hidden="true">
      <span class="checkmark-icon"></span>
    </span>
  `;
};
